import { render } from "./ArtistNew.vue?vue&type=template&id=2529de06"
import script from "./ArtistNew.vue?vue&type=script&lang=js"
export * from "./ArtistNew.vue?vue&type=script&lang=js"
script.render = render

export default script